import { ViewFactory } from 'wdc-cube-react'
import { WhatsAppScope } from '../WhatsApp.scopes'
import { WhatsAppView } from './WhatsApp.views'

export function registerViews(rv = ViewFactory.register) {
    rv(WhatsAppScope, WhatsAppView)
}
